import QuizFormElements from '@/components/DynamicForm/FormElements/ui-kits/quiz/QuizFormElements';
import FormElements from '@/components/DynamicForm/FormElements/ui-kits/default/FormElements';

import { UserInteractionEl } from '../../types/DynamicFormTypes';

import { UserInteractionExpansive } from './expansive/UserInteraction';
import { UiKitsType } from './ui-kits-types';

const UiKits: UiKitsType = {
	quiz: QuizFormElements,
	default: FormElements,
	expansive: {
		...FormElements,
		userInteraction: (props: UserInteractionEl) => <UserInteractionExpansive {...props} />,
	},
};

export default UiKits;
